module.exports = __webpack_public_path__ + "static/media/bel.a780ebc0.png";